/* @jsx h */
import { defineComponent, h } from "vue";
import type { Role } from "./types";

type Props = { roles: Role[]; selected: number[]; onChange?: (ids: number[]) => void };

// Competences as a grid of chips; ticked ones are what the person can work.
export const SkillChips = defineComponent<Props>({
  name: "SkillChips",
  props: ["roles", "selected", "onChange"],
  setup(props) {
    const toggle = (id: number) =>
      props.onChange?.(props.selected.includes(id) ? props.selected.filter((x) => x !== id) : [...props.selected, id]);
    return () => (
      <div class="grid grid-cols-2 gap-2">
        {props.roles.map((r) => {
          const on = props.selected.includes(r.id);
          return (
            <button
              key={r.id}
              type="button"
              disabled={!props.onChange}
              class={[
                "flex items-center justify-between rounded-lg border px-3 py-2 text-sm transition",
                on ? "border-success bg-success/10 font-medium" : "border-base-300 bg-base-200/50 text-base-content/70 hover:border-base-content/30",
              ].join(" ")}
              onClick={() => toggle(r.id)}
            >
              {r.name}
              {on && <span class="material-symbols-outlined text-base text-success">check</span>}
            </button>
          );
        })}
      </div>
    );
  },
});
